import { PipeTransform, Pipe } from "../../../node_modules/@angular/core";
import { GetdataService } from "../services/getdata.service";

@Pipe({
    name:'accountname'
})

export class NavPipe implements PipeTransform{

   // accountdata;
    constructor(private getdataService:GetdataService){

    }
        transform(value:any){
           // var accountname='';
            console.log(value);
            this.getdataService.getAccountNameById(value).subscribe((accountdata) => {
            //   console.log(accountdata[0].account_name);
                let accountname = accountdata[0].account_name;
                console.log(accountname);
                return accountname;
                  },
                err=>{
                  //console.log(err);
                  return false;
                }); 
          
            
        }
}


// WEBPACK FOOTER //
// ./src/app/pipes/nav.pipe.ts